import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce21082c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flowPath" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "账单生成", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "对账、提供发票", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "查看收款记录", -1))
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "本期财务看报", -1))
const _hoisted_8 = { class: "box-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "待结算RMB", -1))
const _hoisted_10 = { class: "box-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "待结算请求数", -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "text-box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "开户名称:", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "银行账号:", -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "开户行:", -1))
const _hoisted_22 = { key: 1 }

import { ArrowRightBold } from "@element-plus/icons-vue";
import card from "@/assets/card.png";
import computer from "@/assets/computer.png";
import { computed, onMounted, reactive, ref } from "vue";
import UserTools from "@/services/session/UserTools";
import finance from "@/api/finance";
import { SettlementAccountInfo } from "@/services/datatype/business/service/settlement/SettlementAccountInfo";
import cycle from "@/utils/CycleUtils";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Income',
  setup(__props) {

const router = useRouter();
//当前是否处于修改状态
const state = ref<boolean>(false);
//表单的dom
const ruleFormRef = ref();
//流程规则
const flowPath = reactive({
  billCreateDayDesc: "",
  invoiceDelayDesc: "",
  recordTips: "",
});
//看板信息
const readANewspaper = reactive({
  RMB: "",
  //请求数
  numberRfRequests: "",
});
//律师收款信息
const collection = reactive({
  //账号名字
  accountName: "",
  // 账号ID
  accountId: "",
  // 银行名
  bankName: "",
});
//效验规则
const rules = {
  accountName: [
    { required: true, message: "开户名称不可以为空!", trigger: "blur" },
  ],
  accountId: [
    { required: true, message: "银行账号不可以为空!", trigger: "blur" },
    { min: 16, max: 19, message: "银行账号只允许16-19位数!", trigger: "blur" },
  ],
  bankName: [{ required: true, message: "开户行不可以为空!", trigger: "blur" }],
};
//只可以输入数字
const isNumber = () =>
  (collection.accountId = collection.accountId.replace(/[^\d]/g, ""));
//提交修改
const modifyLawyer = async () => {
  if (state.value === true) {
    try {
      await ruleFormRef.value.validate();
      const accountInfo = new SettlementAccountInfo();
      const userRoles =
        UserTools.userRoles.roles[localStorage.getItem("userRoleIndex")];
      const getIncome = await finance.getIncome();
      accountInfo.accountId = collection.accountId;
      accountInfo.accountName = collection.accountName;
      accountInfo.bankName = collection.bankName;
      accountInfo.enterpriseId = userRoles.getEnterpriseId();
      accountInfo.creatorId = UserTools.getUserId();
      accountInfo.createTime = new Date().getTime();
      accountInfo.branchName = userRoles.getDisplayName();
      //如果是空表示新增 如果有那就修改
      const accountInfoState = getIncome.getSettlementAccountInfo()
        ? await finance.updateAccountInfo(accountInfo)
        : await finance.addAccountInfo(accountInfo);
      //修改失败就回退吧
      accountInfoState || (await getFinance());
      state.value = false;
    } catch {
      return;
    }
  } else {
    state.value = true;
  }
};
//银行卡格式转换
const getBank = computed(() =>
  collection.accountId
    .replace(/\s/g, "")
    .replace(/(\d{4})/g, "$1 ")
    .replace(/\s*$/, "")
);
//待结算订单明细
const toBeSettled = () =>
  router.push({ path: "/layout/finance/" + cycle.getCurrentTime() });
const getFinance = async () => {
  const getIncome = await finance.getIncome();
  //收益规则
  const checkout = getIncome.getSettlementRuleInfo();
  console.log (getIncome,777888)
  flowPath.billCreateDayDesc = checkout.billCreateDayDesc;
  flowPath.invoiceDelayDesc = checkout.invoiceDelayDesc;
  flowPath.recordTips = checkout.recordTips;
  //面板信息
  const _finance = await finance.getFinance();
  readANewspaper.RMB = (_finance.totalAmountToSettle || 0).toString();
  readANewspaper.numberRfRequests = (
    _finance.totalRequestsToSettle || 0
  ).toString();
  //账号信息
  const accountInformation = getIncome.getSettlementAccountInfo();
  collection.accountName = accountInformation?.accountName || "";
  collection.accountId = accountInformation?.accountId || "";
  collection.bankName = accountInformation?.bankName || "";
};
onMounted(async () => {
  await getFinance();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(flowPath.billCreateDayDesc), 1)
      ]),
      _createVNode(_component_el_icon, {
        size: "2vw",
        color: "#3ca4fc"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowRightBold))
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(flowPath.invoiceDelayDesc), 1)
      ]),
      _createVNode(_component_el_icon, {
        size: "2vw",
        color: "#3ca4fc"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowRightBold))
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(flowPath.recordTips), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("h1", null, _toDisplayString(readANewspaper.RMB), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("h1", null, _toDisplayString(readANewspaper.numberRfRequests), 1)
        ]),
        _createElementVNode("img", { src: _unref(computer) }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", null, [
            _createTextVNode(" 律师收款信息"),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: modifyLawyer
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(state.value ? "确定" : "修改"), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("img", { src: _unref(card) }, null, 8, _hoisted_15),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_form, {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              rules: rules,
              model: collection
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", null, [
                    (state.value)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: "accountName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: collection.accountName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((collection.accountName) = $event)),
                              placeholder: "请输入开户名称!"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_18, _toDisplayString(collection.accountName || "暂未设置开户名称!"), 1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _createElementVNode("div", null, [
                    (state.value)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: "accountId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: collection.accountId,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((collection.accountId) = $event)),
                              placeholder: "请输入银行账号!",
                              maxlength: "19",
                              onInput: isNumber
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_20, _toDisplayString(_unref(getBank) || "暂未设置银行账号!"), 1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _createElementVNode("div", null, [
                    (state.value)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: "bankName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: collection.bankName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((collection.bankName) = $event)),
                              placeholder: "请输入开户行!"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_22, _toDisplayString(collection.bankName || "暂未设置开户行!"), 1))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "settlement",
      onClick: toBeSettled
    }, {
      default: _withCtx(() => [
        _createTextVNode("待结算订单明细")
      ]),
      _: 1
    })
  ], 64))
}
}

})